import * as actions from './actions';
import * as selectors from './selectors';
import types, { moduleName, TYPE_CODE, TYPE_DESCRIPTOR, TYPE_TEXT } from './types';

export { actions as default, moduleName as NAME, selectors, TYPE_CODE, TYPE_DESCRIPTOR, TYPE_TEXT, types };
